import ContentImage from 'components/molecules/ContentImage';
// FIXME:F2TS type import from flow
import { ContentImageProps } from 'components/molecules/ContentImage';
import Slider, { Slide } from 'components/molecules/Slider';
import * as React from 'react';
import Timer from '../Timer/Timer';

export type ContentImageSliderPropsType = {
	id: string | number;
	images?: Array<ContentImageProps>;
	seconds?: number;
};

const ContentImageSlider = ({ id, images, seconds = 0 }: ContentImageSliderPropsType) => {
	if (!Array.isArray(images) || images.length === 0) {
		return null;
	}

	if (images.length === 1) {
		return (
			<div className="h-widen-16">
				<ContentImage
					modifier={seconds ? 'with-timer' : ''}
					image={images[0].image}
					caption={images[0].caption}
				/>
				{seconds > 0 && <Timer id={id} seconds={seconds} />}
			</div>
		);
	}

	return (
		<div className="h-widen-16">
			<Slider modifier={seconds ? 'with-timer' : ''}>
				{images.map((contentImageProps: ContentImageProps, index: number) => {
					const { caption = {} } = contentImageProps;

					return (
						<Slide key={index}>
							<ContentImage
								modifier={contentImageProps.modifier}
								image={contentImageProps.image}
								caption={{
									title: caption.title,
									text: caption.text,
									links: caption.links,
								}}
								slide={[index + 1, images ? images.length : 0]}
							/>
						</Slide>
					);
				})}
			</Slider>
			{seconds > 0 && <Timer id={id} seconds={seconds} />}
		</div>
	);
};

ContentImageSlider.displayName = 'ContentImageSlider';

export default ContentImageSlider;
